import React, { useMemo, useCallback } from 'react';
import { COLORS } from '@gc-npm/utils.enums.colors';
import { useDispatch, useSelector } from 'react-redux';
import ShoppingCartBottom from '@/components/ShoppingCart/ShoppingCartBottom';
import { actions as cartActions } from '@/reducers/cart';
import ModalHeader from '@/components/Modals/Components/modalHeader';
import ShoppingCartModuleList from '@/components/ShoppingCart/ShoppingCartModuleList';
import { LAYOUT_TYPES, API_STATUS, SHOPPING_CART_FOOTER_LAYOUTS } from '@/utils/constants';
import ShoppingCartFooterNew from '@/components/ShoppingCart/ShoppingCartFooterNew';

const ShoppingCartModal = ({
  prices,
  titleOnlyTv,
  resumenText,
  screenType,
  buttonTextMobile,
  buttonTextMobileConfirmation,
  legalText,
  legalTextNoClte,
}) => {
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const layout = useSelector((state) => state.UI.layout);
  const statusModulos = useSelector((state) => state.modulos.statusModulos);
  const statusSelection = useSelector((state) => state.modulos.statusSelection);

  const isLoading = (statusModulos === API_STATUS.LOADING)
    || (statusSelection === API_STATUS.LOADING);

  // Calcula los módulos de forma condicional solo si cambia el layout o los módulos en el carrito
  const modulos = useMemo(() => {
    const modules = cart?.modulos;

    if (layout === LAYOUT_TYPES.CONECTIVIDAD) {
      modules.tv = null;
    } else if (layout === LAYOUT_TYPES.TV) {
      modules.conectividad = null;
    }

    return modules;
  }, [layout, cart]);

  const onClickHandlerPurchase = useCallback(() => {
    dispatch(cartActions.purchase());
  }, [dispatch]);

  if (!Object.keys(modulos).length) {
    return null;
  }

  // Todo: controlar si se usa un texto u otro según la URL
  const titleModal = titleOnlyTv;
  const shoppingCartProps = {
    onClick: onClickHandlerPurchase,
    modulos,
    prices,
    titleOnlyTv,
    resumenText,
    screenType,
    buttonTextMobileConfirmation,
    buttonTextMobile,
    isLoading,
    taggingInfoName: 'shoppingCart',
  }
  return (
    <div className="shoppingCartModal">
      <ModalHeader title={titleModal} />
      <div className="moduleList">
        <ShoppingCartModuleList modulos={modulos} screenType={screenType} isLoading={isLoading} />
      </div>

      <hr />
      <div className="shoppingCartModalBottom">
        <ShoppingCartBottom
          legalText={legalText}
          legalTextNoClte={legalTextNoClte}
          prices={prices}
          isLoading={isLoading}
          modulos={modulos}
        />
      </div>
      <div className="shoppingCartModalFooter">
        <ShoppingCartFooterNew
          {...shoppingCartProps}
          layoutType={SHOPPING_CART_FOOTER_LAYOUTS.CONFIG_MOBILE_FLYOUT}
        />
      </div>

      <style jsx>
        {`
        .shoppingCartModal {
          min-height: 50vh;
          max-height: 80vh;
          overflow: scroll;
          background-color: white;
          min-width: 100vw;
          border-radius: 1rem 1rem 0 0;
          padding: 1rem;
          display: block;
          .moduleList{
            padding: 1rem 0;
          }
          .shoppingCartModalBottom{
            padding: 1rem 0;
          }
        }
        .titleItems {
          padding: 1rem 0 1rem 0;
        }
        hr {
          width: 100%;
          color: ${COLORS.grey300};
        }
      `}
      </style>
    </div>
  );
};

export default ShoppingCartModal;
